import React, { useEffect } from "react";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import Redirect from "@frameworks/web/assets/images/features/TOC/Common/redirect.svg";
import RedirectBack from "@frameworks/web/assets/images/features/TOC/Common/RedirectBack.svg";
import { Col, Row } from "react-bootstrap";
var ClosingComponent = function (props) {
    useEffect(function () {
        if (!props.sideComponent) {
            setTimeout(function () {
                window.close();
            }, 2500);
        }
    }, []);
    return (React.createElement(GridContainer, { parentClass: "error-block-state text-center mgt-100 mb-150" },
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12, className: "taCenter pt-30 pb-30  mgt-25" },
                React.createElement("img", { src: props.sideComponent ? Redirect : RedirectBack }))),
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12 },
                React.createElement("div", { className: "DMSan_23_700 txt_blackOne1 mgt-25" }, "Redirecting"),
                React.createElement("div", { className: "DMSanN_16_400 txt_blackOne1" }, props.sideComponent
                    ? "Please wait while we connect you to the bank"
                    : "Please wait while we connect you back")))));
};
export default ClosingComponent;
